import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import s from './PanelInputField.scss';
const PanelInputField = (_param)=>{
    var { label, input, rootTag: Tag = 'div' } = _param, rest = _object_without_properties(_param, [
        "label",
        "input",
        "rootTag"
    ]);
    return /*#__PURE__*/ React.createElement(Tag, _object_spread({
        className: s['root']
    }, rest), label, input);
};
PanelInputField.displayName = 'PanelInputField';
export default PanelInputField;

//# sourceMappingURL=PanelInputField.js.map